// External Dependencies:
import axios from 'axios'
import Cookies from 'js-cookie'
import { Link } from 'react-router-dom'

export function addScript( value ) {
	return {
		type: 'ADD_SCRIPT',
		payload: value
	}
}

export function getScreenSize() {
	return {
		type: 'GET_SCREEN_SIZE'
	}
}

export function openMenu() {
	return {
		type: 'OPEN_MENU'
	}
}

export function closeMenu() {
	return {
		type: 'CLOSE_MENU'
	}
}

export function setSidebarVisibility( val ) {
	return {
		type: 'SET_SIDEBAR_VISIBILITY',
		payload: val
	}
}

export function setDisclaimerConsent( value ) {
	return {
		type: 'SET_DISCLAIMER_CONSENT',
		payload: value
	}
}

export function getVideosData() {
	return function( dispatch, getState ) {
		const { videos } = getState().site

		// Short circuit for existing data:
		if ( Object.keys( videos ).length ) {
			return
		}

		const url = `${siteData.api_base_url}videos`

		return axios({
				url: url,
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then( function( response ) {
				dispatch( receiveVideosData( response.data ) )
			})
			.catch( function( error ) {
				console.log( error, 'error' );
			})
	}
}

export function receiveVideosData( json ) {
	return {
		type: 'RECEIVE_VIDEOS_DATA',
		payload: json
	}
}

export function getPeopleData() {
	return function( dispatch, getState ) {
		const { people } = getState().site

		// Short circuit for existing data:
		if ( Object.keys( people ).length ) {
			return
		}

		const url = `${siteData.api_base_url}people`

		return axios({
				url: url,
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then( function( response ) {
				dispatch( receivePeopleData( response.data ) )
			})
			.catch( function( error ) {
				console.log( error, 'error' );
			})
	}
}

export function receivePeopleData( json ) {
	return {
		type: 'RECEIVE_PEOPLE_DATA',
		payload: json
	}
}



// WEBPACK FOOTER //
// ./redux/actions/site.jsx